import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class RadniDani{

    daLiJeRadniDan(jsDate: Date):boolean{
        return jsDate.getDay()!=6 && jsDate.getDay()!=0;
    }
    
    ngbDaLiJeRadniDan(ngbDate: NgbDate):boolean{
        return this.daLiJeRadniDan(new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day));
    }

    dajSledeciRadniDan(jsDate: Date):Date{
        jsDate.setDate(jsDate.getDate()+1);
        while (!this.daLiJeRadniDan(jsDate)){
            jsDate.setDate(jsDate.getDate()+1);
        }
        return jsDate;
    }

    ngbDajSledeciRadniDan(ngbDate: NgbDate):NgbDate{
        let jsDate:Date=new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day)
        jsDate=this.dajSledeciRadniDan(jsDate);
        const ngbDate1:NgbDate=new NgbDate(jsDate.getFullYear(), jsDate.getMonth()+1, jsDate.getDate());
        return ngbDate1;
    }

    dajBrojRadnihDana(jsDate1: Date, jsDate2: Date):number{
        let numOfDays:number=0;
        while (jsDate1<=jsDate2){
            if (this.daLiJeRadniDan(jsDate1))
                numOfDays=numOfDays+1;
            
                jsDate1.setDate(jsDate1.getDate()+1);
        }
        return numOfDays;
    }

    ngbDajBrojRadnihDana(ngbDate1: NgbDate, ngbDate2: NgbDate):number{
        if (ngbDate1 && ngbDate2)
            return this.dajBrojRadnihDana(
                new Date(ngbDate1.year, ngbDate1.month - 1, ngbDate1.day)
                , new Date(ngbDate2.year, ngbDate2.month - 1, ngbDate2.day)
            );
        else
            return 0;
    }
}